import React, { useState, useEffect } from "react";
import { FieldArray, useFormikContext } from "formik";
import FormikInput from "../../../Formik/FormikInput";
import FormikSelect from "../../../Formik/FormikSelect";
import styled from "styled-components";
import { useLanguage } from "../../../LangTranslation/LanguageContext";
import SocialMedia from "./SocialMedia";
import { findAndAddOption } from "../../../../utilities/findAndAddOption";
import { countryChangeDefaultValues } from "../../../../utilities/Validation Schema/onChangeDefaultOptions";
import useListOptions from "../../../../CustomHooks/useListOptions";
import { onChangeSelectContact } from "../../../../DataApi/contacts/onchangeSelectContact";
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }
`;

const General = ({
  disabled,
  context,
  company_id,
  activeSocialMediaList,

  // options
  stateList,
  setStateList,
  counryList,
  setCounryList,
  currencyList,
  setCurrencyList,
  mailTemplateList,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const { handleCustomSearch } = useListOptions();

  const t = translations[language];

  const handleChangeCountry = async (
    option,
    { name },
    values,
    setFieldValue
  ) => {
    // console.log("values", values);
    const {
      state,
      country,
      currency,
      bank,
      bank_ids,
      active_SocialMedia_List,
      ...valuesWithoutExcludedKeys
    } = values;
    const modifiedBankIds = bank_ids
      ? bank_ids.map(({ bank, isDeleted, ...rest }) => rest)
      : [];
    if (modifiedBankIds.length > 0) {
      valuesWithoutExcludedKeys.bank_ids = modifiedBankIds;
    }

    const response = await onChangeSelectContact({
      id: [values.id],
      company_id,
      context,
      keyChange: "country_id",
      values: { ...valuesWithoutExcludedKeys, [name]: option.value },
      model: "res.company",
      defaulChange: countryChangeDefaultValues,
    });
    findAndAddOption({
      availableOptions: counryList,
      incomingOption: [option.value, option.label],
      setAvailableOptions: setCounryList,
    });
    const incomingValues = response?.result?.value || {};

    setFieldValue("state_id", incomingValues?.state_id?.[0] || false);
    setFieldValue(
      "currency_id",
      incomingValues?.currency_id?.[0] || values.currency_id
    );
    if (incomingValues?.currency_id) {
      findAndAddOption({
        incomingOption: incomingValues?.currency_id,
        setAvailableOptions: setCurrencyList,
      });
    }

    handleCustomSearch({
      model: "res.country.state",
      args: [["country_id", "=?", option.value]],
      context: { ...context },
      setState: setStateList,
      staticOptions: incomingValues?.state_id ? [incomingValues?.state_id] : [],
    });
  };

  return (
    <div>
      <FormContainer className="row g-3 px-2">
        <div className="col-md-12">
          <FormikInput
            disabled={disabled}
            type="text"
            name="street"
            label={t["Address"]}
          />
        </div>
        <div className="col-md-4">
          <FormikInput
            disabled={disabled}
            type="text"
            name="city"
            label={t["City"]}
          />
        </div>
        <div className="col-md-4">
          <FormikSelect
            name="state_id"
            options={stateList}
            disabled={disabled}
            label={t["State"]}
            placeholder={t["State"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "res.country.state",
                context: { ...context, active_test: false },
              })
            }
          />
        </div>
        <div className="col-md-4">
          <FormikInput
            disabled={disabled}
            type="number"
            name="zip"
            label={t["Zip"]}
          />
        </div>
        <div className="col-md-6">
          <FormikSelect
            name="country_id"
            disabled={disabled}
            options={counryList}
            placeholder={t["Country"]}
            label={t["Country"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "res.country",
              })
            }
            onChange={(option, event) => {
              handleChangeCountry(option, event, values, setFieldValue);
            }}
          />
        </div>
        <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            name="currency_id"
            options={currencyList}
            placeholder={t["Currency"]}
            label={t["Currency"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "res.currency",
                context: { ...context, active_test: false },
              })
            }
          />
        </div>

        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="phone"
            label={t["Phone"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="email"
            name="email"
            label={t["Email"]}
          />
        </div>
        {/* <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            name="sales_notify_template_id"
            options={mailTemplateList}
            placeholder={"Email Template"}
            label={t["Sales Team Notify Template"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "mail.template",
                context: { ...context, active_test: false },
              })
            }
          />
        </div> */}
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="char"
            label={t["Website Link"]}
            name="website"
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="vat"
            label={t["Tax ID"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="text"
            name="company_registry"
            label={t["Company Registry"]}
          />
        </div>

        <div>
          <FieldArray
            name="active_social_media_lines"
            render={({ ...args }) => {
              return (
                <SocialMedia
                  {...args}
                  disabled={disabled}
                  context={context}
                  company_id={company_id}
                  activeSocialMediaList={activeSocialMediaList}
                />
              );
            }}
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default General;
